//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["dataConfig", "parent", "tabPageId"],
  data() {
    return {
      $parent2: null,
      isLoading: false,
      isFinished: false,

      isFirst: false,

      Page: {
        PageSize: 10,
        PageIndex: 1,
        PageCount: 0
      }
    };
  },

  created() {
    console.log(this.dataConfig, "dataConfig");
    if (this.parent) {
      this.$parent2 = this.parent;
    } else {
      this.$parent2 = this.$parent;
    }
  },
  mounted() {},
  methods: {

    $getSubmitData(){      
      var formData = this.$parent.$getSubmitData();
      return formData;
    },

    $getActionObj() {
      var actionObj = this.$parent.$getActionObj();
      return actionObj;
    },

    onClickItem(dataItem, index) {
      console.log("onClickItem", dataItem);
      //this.onDetailClick2(dataItem,index);
      this.$parent2.onDetailClick(dataItem, index);
    },

    async onPageLoad() {
      if (!this.isFirst) {
        this.isFirst = true;
        this.isLoading = false;
        return;
      }
      var pageIndex = this.Page.PageIndex + 1;
      var pageSize = this.Page.PageSize;
      await this.getIndexPaged(pageIndex, pageSize);
    },

    async $refreshForm(){

      this.isFinished = false;
      
      this.isFirst = true;

      this.Page.PageIndex = 0;
      this.Page.pageSize = 10;

      if(this.dataConfig.DataList && this.dataConfig.DataList.length > 0){
        this.dataConfig.DataList.splice(0,this.dataConfig.DataList.length);
      }
      await this.onPageLoad();

    },

    async getIndexPaged(pageIndex, pageSize) {
      //var url = "/mTplApi/Template/GetIndexPaged";

      this.$msg.showLoading("正在获取详细信息...");
      var postData = this.$getSubmitData();
      if(!postData){
        postData = {};
      }

      postData.PageIndex = pageIndex;
      postData.PageSize = pageSize;

      if (this.tabPageId) {
        postData.TabPageId = this.tabPageId;
      }
      console.log(this.dataConfig, "this.dataConfig");
      postData.QueryValue = this.dataConfig.QueryValue;

      console.log("postData", postData);

      var result = await this.$parent2.getIndexPaged(postData);

      this.$msg.hideLoading();
      this.isLoading = false;
      if (result.state == 1) {
        this.Page = result.data.Page;
        if (this.Page.PageIndex >= this.Page.PageCount) {
          this.isFinished = true;
        }

        if (result.data.Rows) {
          this.dataConfig.DataList = this.dataConfig.DataList.concat(
            result.data.Rows
          );
        }

        return;
      }

      console.log("dataConfig.DataList", this.dataConfig.DataList);
    }
  }
};
